import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-10 md:py-14 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto text-center" data-id="element-61">
      <motion.div initial={{
      opacity: 0,
      scale: 0.9
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} className="flex flex-col items-center" data-id="element-62">
        <div className="w-20 h-20 bg-primary-card rounded-full flex items-center justify-center mb-4 border-4 border-accent-cyan/20" data-id="element-63">
          <ShieldCheck className="w-10 h-10 text-accent-cyan" data-id="element-64" />
        </div>

        <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-65">
          Riesgo Cero para vos.
        </h2>

        <p className="text-lg text-text-muted leading-relaxed" data-id="element-66">
          Si el material no es lo que esperabas para tus clases técnicas, te
          devolvemos el 100% de tu dinero. Así de seguros estamos de nuestro
          trabajo.
        </p>
      </motion.div>
    </section>;
}